import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Grid } from "@mzc-pdc/ui";
import Typography from "@components_v2/typography/typography";
import { CATEGORY_TYPES } from "@constants";
import Categories from "@routes/categories";
import { updateData } from "@modules/createAsset";

const CategoriesField = ({ categoryGroup, setCategoryGroup, setCategoryGroupTooltipDisabled, categoryGroupTooltipDisabled }) => {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const categories = useSelector(({ createAsset }) => createAsset.data.categories);

    const onChangeCategories = (options) => {
        dispatch(
            updateData({
                categories: options.categories,
            }),
        );
        if (options.categoryGroup) {
            setCategoryGroupTooltipDisabled(categoryGroup?.id === options.categoryGroup?.id);
            setCategoryGroup({ id: options.categoryGroup.id, name: options.categoryGroup.label });
        }
    };

    return (
        <Grid container alignItems={"center"} mb={2.5}>
            <Grid item sx={{ alignSelf: "flex-start", minWidth: "244px" }} alignItems={"center"}>
                <Typography variant={"body1"} component={"p"} mt={"10px"}>
                    {t(`common::label::Categories`, `Categories`)}
                </Typography>
            </Grid>
            <Grid
                item
                sx={{
                    flex: 1,
                    alignSelf: "flex-start",
                    maxWidth: "1000px",
                }}
            >
                <Categories
                    tooltipDisabled={categoryGroupTooltipDisabled}
                    categoryGroups={true}
                    selectedCategoryGroup={{
                        id: categoryGroup?.id,
                        label: categoryGroup?.name,
                    }}
                    placeholder={t(`common::label::${"Select category"}`)}
                    type={CATEGORY_TYPES.ASSET}
                    selectedValues={categories?.map((category) => ({
                        label: category.name,
                        name: category.name,
                        value: category.id,
                        id: category.id,
                    }))}
                    onChange={onChangeCategories}
                />
            </Grid>
        </Grid>
    );
};

export default CategoriesField;
